import React from 'react';
import PropTypes from 'prop-types';
import { TabList, mergeClasses } from '@fluentui/react-components';
import { SideNavigationItem } from '@bingads-webui-fluent-component/navigation';
import { handleRealUsedFlag, RealUsedFlagSuffix } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

import { useAdStudioNavigation } from './use-ad-studio-navigation';
import { FolderPathTreeView } from './components/folders-tree-view';
import { useAdStudioNavigationStyle } from './style';

const AdStudioNavigationImp = ({
  history,
  i18n,
  rootRoute,
  dataService,
  logger,
  permissions,
  onDropToFolder: onDropToFolderProp,
  adsStudioAccountPreferences,
}) => {
  const {
    staticItems,
    selectedItemId,
    setSelectedFolderId,
    folderPathTree,
    loadFolderPathTreeItem,
    loadMoreFolderPathTreeItem,
    handleFolderItemClicked,
    onDropToFolder,
    navigateIntoRootFolder,
  } = useAdStudioNavigation({
    history,
    rootRoute,
    dataService,
    onDropToFolder: onDropToFolderProp,
    permissions,
    adsStudioAccountPreferences,
  });

  const classes = useAdStudioNavigationStyle();
  return (
    <>
      <div className={mergeClasses(classes.adStudioNavigation, 'ad-studio-navigation')}>
        <TabList vertical selectedValue={selectedItemId} appearance="subtle">
          {staticItems.map(item => (
            <div key={item.id}>
              {
                item.showDivider &&
                <div className={classes.divider}>
                  <div className={classes.dividerContent} />
                </div>
              }
              <SideNavigationItem
                groupId={item.id}
                item={{
                  id: item.id,
                  icon: item.icon,
                  text: i18n.getString(item.name),
                  onClick: () => {
                    handleRealUsedFlag(adsStudioAccountPreferences, RealUsedFlagSuffix.App);
                    setSelectedFolderId(null);
                    navigateIntoRootFolder();
                    item.onClick();
                    logger.logTrace('AdStudioNavigation: static item clicked', { navigationItem: item.name });
                  },
                }}
                selectedTabId={selectedItemId}
                config={{}}
                className={classes.customTabItem}
              />
            </div>
          ))}
          {
            folderPathTree && folderPathTree.subFolders.length > 0 &&
            <FolderPathTreeView
              folderPathTree={folderPathTree}
              loadFolderPathTreeItem={loadFolderPathTreeItem}
              loadMoreFolderPathTreeItem={loadMoreFolderPathTreeItem}
              i18n={i18n}
              onItemSelected={handleFolderItemClicked}
              selectedItemId={selectedItemId}
              logger={logger}
              onDrop={onDropToFolder}
            />
          }
        </TabList>
      </div>
      <div className={mergeClasses(classes.placeholder, 'ad-studio-navigation-placeholder')} />
    </>
  );
};

AdStudioNavigationImp.propTypes = {
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  rootRoute: PropTypes.string.isRequired,
  dataService: PropTypes.shape({
    folderPathTree: PropTypes.arrayOf(PropTypes.shape({})),
    loadFolderPathTreeItem: PropTypes.func,
    loadMoreFolderPathTreeItem: PropTypes.func,
  }).isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
  onDropToFolder: PropTypes.func.isRequired,
};

export const AdStudioNavigation = AdStudioNavigationImp;
